"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _core = require("../core");

var _utils = require("../utils");

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    },
    gutters: {
      paddingLeft: function paddingLeft(props) {
        return props.hasLeftIcon ? 0 : theme.spacing(1);
      },
      paddingRight: theme.spacing(2),
      '@media (min-width: 600px)': {
        paddingLeft: function paddingLeft(props) {
          return props.hasLeftIcon ? theme.spacing(1) : theme.spacing(2);
        },
        paddingRight: theme.spacing(3)
      }
    },
    leftIcon: {
      '& > :nth-child(n)': {
        padding: theme.spacing(1),
        boxSizing: 'content-box'
      },
      marginRight: theme.spacing(0.5),
      display: 'flex',
      color: theme.palette.grey[600]
    },
    rightIcons: {
      marginLeft: 'auto',
      display: 'flex',
      color: theme.palette.grey[600],
      '& > :nth-child(n)': {
        padding: theme.spacing(1),
        marginLeft: theme.spacing(1),
        boxSizing: 'content-box'
      }
    },
    title: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    iconLogo: {
      marginLeft: function marginLeft(props) {
        return props.hasRightIcons ? theme.spacing(2) : 'auto';
      },
      width: 48
    }
  };
}, {
  name: (0, _core.rochePrefix)('TopBar')
});
exports.useStyles = useStyles;